package dev.lingvo.shared.screenshots.templates

import dev.lingvo.shared.screenshots.doc.BackgroundLayer
import dev.lingvo.shared.screenshots.doc.Board
import dev.lingvo.shared.screenshots.doc.Box
import dev.lingvo.shared.screenshots.doc.BrandKit
import dev.lingvo.shared.screenshots.doc.FitSpec
import dev.lingvo.shared.screenshots.doc.LayerBase
import dev.lingvo.shared.screenshots.doc.Page
import dev.lingvo.shared.screenshots.doc.Paint
import dev.lingvo.shared.screenshots.doc.Role
import dev.lingvo.shared.screenshots.doc.SceneKind
import dev.lingvo.shared.screenshots.doc.SceneSpec
import dev.lingvo.shared.screenshots.doc.TextContent
import dev.lingvo.shared.screenshots.doc.TextLayer
import dev.lingvo.shared.screenshots.doc.TextStyle
import dev.lingvo.shared.screenshots.scene.namespaceDigest

/** A graphic is ordinary editable artwork; a device silhouette would introduce an unnecessary capture dependency. */
internal fun featureGraphicPages(brand: BrandKit, board: Board, slots: List<TemplateSlot>, family: String): List<Page> {
    require(slots.size == 1) { "A feature graphic belongs to exactly one plan slot." }
    val id = "fg-${namespaceDigest(board.id).take(20)}"
    return listOf(Page(id, listOf(slots.single().slotKey), SceneSpec(SceneKind.SINGLE), listOf(
        BackgroundLayer(LayerBase("$id-bg", box = Box(0.0, 0.0, 1024.0, 500.0)), Paint.Solid("@bg")),
        TextLayer(LayerBase("$id-brand", box = Box(64.0, 48.0, 896.0, 60.0), role = Role.EYEBROW),
            TextContent.Literal(brand.name), TextStyle(family = family, color = Paint.Solid("@inkMuted")), FitSpec(36.0, 24.0, 1)),
        TextLayer(LayerBase("$id-caption", box = Box(64.0, 148.0, 896.0, 280.0), role = Role.CAPTION),
            TextContent.SlotCaption(), TextStyle(family = family, color = Paint.Solid("@ink")), FitSpec(80.0, 36.0, 3)),
    )))
}
